import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { Typography } from '@mui/material';

const useStyles = makeStyles()((theme) => ({
    root: {
        padding: '0 0 15px 0',
        textAlign: 'center',
        marginRight: 'auto',
        marginLeft: 'auto',
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        color: theme.palette.default.contrastText,
        [theme.breakpoints.down('md')]: {
            justifyContent: 'none',
            flexWrap: 'wrap',
            '& > div': {
                flexGrow: 1,
                marginTop: 10
            }
        }
    },
    icon: {
        height: 44
    },
    title: {
        [theme.breakpoints.down('md')]: {
            display: 'none'
        }
    }
}));

export const Sponsors = ({ data }) => {
    const { classes: clasess } = useStyles();

    return (
        <div className={clasess.root}>
            {data.map(({ title, url, imgSrc }) => (
                <div key={url}>
                    <Typography className={clasess.title} gutterBottom>
                        {i18n(title)}
                    </Typography>
                    <a href={url} target="_blank" rel={url === 'https://wallarm.com/' ? '' : 'nofollow'}>
                        <img className={clasess.icon} src={imgSrc} />
                    </a>
                </div>
            ))}
        </div>
    );
};
